import { SemanticAttributes } from '@opentelemetry/semantic-conventions';
import { isSentryRequestUrl, getCurrentHub } from '@sentry/core';

/**
 *
 * @param otelSpan Checks wheter a given OTEL Span is an http request to sentry.
 * @returns boolean
 */
function isSentryRequestSpan(otelSpan) {
  const { attributes } = otelSpan;

  const httpUrl = attributes[SemanticAttributes.HTTP_URL];

  if (!httpUrl) {
    return false;
  }

  return isSentryRequestUrl(httpUrl.toString(), getCurrentHub());
}

export { isSentryRequestSpan };
//# sourceMappingURL=isSentryRequest.js.map
